import Vue from 'vue'
import configs from '@/config'
import constants from '@/constant'

let resource = null

const actions = {
  sendCountingUnique: {
    method: 'PUT',
    url: `${configs.liveProxyUrl}/api/live/counting/unique`,
  },
  sendCountingUniqueNewKafka: {
    method: 'PUT',
    url: `${configs.liveProxyUrl}/api/${constants.LiveProxyRootPath}/counting/unique`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const sendCountingUnique = async (payload) => {
  return resource.sendCountingUnique(payload)
}

export default {
  initResource,
  sendCountingUnique,
}
